import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { bootstrapAnalytics, trackPageView } from "@/lib/analytics";

/** Boots GA4 once and fires a page_view on each SPA route change. */
const AnalyticsRouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    bootstrapAnalytics();
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsRouteTracker;
